"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const meetingBulletinsList = (0, graphql_tag_1.default)`
  ${data_1.pageInfoFields}
  ${data_1.documentSchemaFields}
  query meetings_meeting_bulletins_list(
    $before: Int
    $after: Int
    $first: Int
    $last: Int
    $meetingId: Int!
    $filters: [FilterCoreInput]
    $search: String
    $sort: BulletinListSortInput
    $sortByCheckbox: CheckboxSortInput
    $shouldFetchIds: Boolean!
  ) {
    meetings {
      meeting {
        bulletins {
          list(
            meetingId: $meetingId
            filters: $filters
            first: $first
            after: $after
            before: $before
            last: $last
            search: $search
            sort: $sort
            sortByCheckbox: $sortByCheckbox
          ) {
            pageInfo {
              ...pageInfoFields
            }
            totalCount
            edges {
              cursor
              node {
                id
                users {
                  id
                  active
                  accessLevel
                  avatarUrl
                  avatarColor
                  avatarBorderColor
                  avatarText
                  avatarDisplayName
                  showMyAvatar
                  allowMeeting
                  whyNotAllowMeeting
                }
                apartmentNumbers
                apartmentAddresses
                lastModifyDate
                votePercent
                registrationType
                votingFlags {
                  virtualVotingStatus
                  normalVotingStatus
                }
                callCenterCard {
                  cardId
                  status
                  nextContactDate
                  comment
                  commentDocuments {
                    ...documentSchemaFields
                  }
                }
              }
            }
            ids @include(if: $shouldFetchIds)
          }
        }
      }
    }
  }
`;
exports.default = meetingBulletinsList;